export default "__VITE_ASSET__OesZu$Yd__"